import {
  PROGRESS_BAR_ITEMS_FOR_VIRTUAL_SERVICE,
  EDIT_PROGRESS_BAR_ITEMS_FOR_VIRTUAL_SERVICE,
} from './progress-bar-items.config';
import { PATH_NAMES } from '../constants';
import { services } from '~/ocab-services/services.constant';

export const config = {
  v3: {
    PROGRESS_BAR_ITEMS: PROGRESS_BAR_ITEMS_FOR_VIRTUAL_SERVICE,
    EDIT_PROGRESS_BAR_ITEMS: EDIT_PROGRESS_BAR_ITEMS_FOR_VIRTUAL_SERVICE,
    shopsNextPath: PATH_NAMES.SELECT_DATE,
    editShopNextPath: PATH_NAMES.EDIT_DATE,
    editMode: {
      firstEditPagePath: PATH_NAMES.EDIT_DATE,
      hideEditDateTitle: true,
      hideGoBackButton: true,
    },
    selectDateTitle: 'Select a date',
    subtitleComponent: ({ classNameForSubtitleWithLink }) => (
      <div className={classNameForSubtitleWithLink}>
        <p>Our consultations are carried out online so you can receive expert advice anywhere at a time that works for you.</p>
      </div>
    ),
    getSelectDateExternalPrevPath: envConfig => envConfig.services[services.BEAUTY_SOCIETY.name].landingPageUrl,
    ReviewForm: {
      hideShopDetails: true,
    },
    SuccessBookingMessage: {
      paragraph: null,
    },
    BookingReview: {
      hideShopDetails: true,
      hidePhoneSection: true,
    },
  },
};
